if (!customElements.get('kiki-workshop-booking')) {
  customElements.define('kiki-workshop-booking', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const select = this.querySelector('select');
      const venue = this.querySelector('[data-workshop-venue]');
      const book = this.querySelector('[data-workshop-book]');
      const dialog = this.querySelector('dialog');
      select.addEventListener('change', () => {
        venue.textContent = select.selectedOptions[0].dataset.venue || '';
        venue.hidden = !venue.textContent;
      });
      if (!book) return;
      book.addEventListener('click', event => {
        if (!select.value) {
          event.preventDefault();
          select.focus();
          select.setCustomValidity(select.options[0].textContent);
          select.reportValidity();
          return;
        }
        if (!dialog) return;
        event.preventDefault();
        dialog.querySelector('[data-selected-date]').textContent = select.value + (venue.textContent ? ' · ' + venue.textContent : '');
        const frame = dialog.querySelector('iframe');
        if (!frame.getAttribute('src')) frame.src = frame.dataset.bookingSrc;
        dialog.showModal();
      });
      select.addEventListener('change', () => select.setCustomValidity(''));
    }
  });
}
